module.exports = __webpack_public_path__ + "img/skipping_card.fd3b2e76.svg";